import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cx } from 'react-emotion';
import classnames from 'classnames';
import { Button, ButtonTitle } from 'web-ui-components/lib/atoms/buttons';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { formatSortCode } from '../../utils/accountUtils';

import styles from './CardSelector.styles';

const getPayeeDetails = (selectedAccount) => {
	if (selectedAccount.type === 'credit_card') {
		return selectedAccount.number;
	}
	if (selectedAccount.accountNumber && selectedAccount.sortCode) {
		return `${formatSortCode(selectedAccount.sortCode)} | ${selectedAccount.accountNumber}`;
	}
	if (selectedAccount.iban) {
		return selectedAccount.iban;
	}
	return selectedAccount.accountNumber;
};
class CardSelector extends Component {
	constructor(props) {
		super(props);
		this.renderSelectedCard = this.renderSelectedCard.bind(this);
		this.renderSelectorCard = this.renderSelectorCard.bind(this);
	}
	componentDidUpdate() {
		const { isFocusOn, id } = this.props;
		if (isFocusOn && this[id]) {
			this[id].focus();
		}
	}
	renderSelectedCard() {
		const { onClick, selectedAccount, disabled } = this.props;
		return (
			<button
				className={classnames(
					'c-m-payment-control__selected',
					'c-m-payment-control__selected--is-visible',
					'c-a-button--secondary',
					{ [styles.disabledVM]: disabled }
				)}
				onClick={onClick}
				disabled={disabled}
			>
				{selectedAccount.accountHolder && (
					<span className={cx('c-m-payment-control__selected-meta', styles.accountHolder)}>
						{selectedAccount.accountHolder}
					</span>
				)}
				<Identifier.Breaking>
					<span className="c-m-payment-control__selected-name">{selectedAccount.displayName}</span>
				</Identifier.Breaking>
				<span className="c-m-payment-control__selected-meta">{getPayeeDetails(selectedAccount)}</span>
			</button>
		);
	}
	renderSelectorCard() {
		const { id, title, iconType, onClick, disabled, onBlur } = this.props;
		return (
			<Button
				id={id}
				display="secondary"
				onClick={onClick}
				disabled={disabled}
				ref={(element) => {
					this[id] = element;
				}}
				onBlur={onBlur}
				data-cy={id}
				className={classnames({ [styles.disabledVM]: disabled })}
			>
				<Icon iconType={iconType} />
				<ButtonTitle>{title}</ButtonTitle>
			</Button>
		);
	}
	render() {
		const { selectedAccount } = this.props;
		return selectedAccount ? this.renderSelectedCard() : this.renderSelectorCard();
	}
}

CardSelector.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	iconType: PropTypes.string.isRequired,
	selectedAccount: PropTypes.shape({
		displayName: PropTypes.string.isRequired,
		sortCode: PropTypes.string,
		type: PropTypes.string,
		number: PropTypes.string,
		accountNumber: PropTypes.string,
		iban: PropTypes.string,
		accountHolder: PropTypes.string,
	}),
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	isFocusOn: PropTypes.bool,
	onBlur: PropTypes.func,
};

getPayeeDetails.defaultProps = {};

export default CardSelector;
